export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/4-2da6ed9b8ca2e4b4c0792b7ab476eca7.svg";